// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1RMBy","image":"Header_image__2q3ZB","name":"Header_name__1qLlT","info":"Header_info__13EoQ","infoRow":"Header_infoRow__3uTcf"};